import questionnaireResponsesSchema from './questionnaireResponsesSchema'

const moodFormSchema = (t) => questionnaireResponsesSchema(t)

export default moodFormSchema
